/* eslint-disable import/no-unused-modules */
/* eslint-disable react/display-name */
import React, { useMemo } from 'react';
import { groupBy } from 'lodash';
import PropTypes from 'prop-types';
import Tippy from '@tippy.js/react';
import { newConditionIndices } from 'helpers/constants';
import { translate } from 'helpers/translateHelper';
import { IconCondition } from 'svgIcons/MotionPortalIcons';
import { conditionIndices } from './constants';
// import KPIListViewComponent from './KPIListViewComponent';

// Optimized renderThreshold Component
const ThresholdViewComponent = React.memo(({ item, isLabelVisible, leftPanelSize }) => {
    const conditions = [
        conditionIndices.POOR,
        conditionIndices.TOLERABLE,
        conditionIndices.UNKNOWN,
        conditionIndices.GOOD,
        conditionIndices.UNSUPPORTED
    ];
    const isLeftPanelclosed = leftPanelSize > 50;

    const getConditionData = (groupOfKPIs, condition, isTrend = false, iconCondition) => {
        return {
            count: groupOfKPIs[condition]?.length || 0,
            icon: newConditionIndices[condition]?.iconID !== undefined && newConditionIndices[condition]?.iconID !== null ?
                isTrend && iconCondition === conditionIndices.TOLERABLE ? <IconCondition condition={4} /> : <IconCondition condition={newConditionIndices[iconCondition]?.iconID} /> :
                null
        };
    };

    const renderThresholdConditions = useMemo(() => {
        const groupOfKPIs = groupBy(item?.threshold?.KPIs, 'condition');
        const kpiList = item?.threshold?.KPIs;

        const selectedCondition = conditions.find(condition => groupOfKPIs[condition]?.length > 0) || null;
        const { count, icon } = selectedCondition ? getConditionData(groupOfKPIs, selectedCondition, false, item?.threshold?.condition) : { count: null, icon: '' };

        // Show count only for POOR and TOLERABLE conditions
        const shouldShowCount = count && (selectedCondition === conditionIndices.POOR || selectedCondition === conditionIndices.TOLERABLE);

        const renderKPIs = () => {
            return kpiList && kpiList?.length > 0 ?
                <div className='render-condition'>
                    {icon}
                    {shouldShowCount && isLabelVisible &&
                        <div className='kpis'>
                            {isLeftPanelclosed ? `${count} ${count === 1 ?
                                translate('ABB.Powertrain.Frontend.conditionOverviewConditionIndicesLabel') :
                                translate('ABB.Powertrain.Frontend.conditionOverviewConditionIndicesLabels')}` : null}
                        </div>
                    }
                </div> :
                item?.threshold?.condition === conditionIndices.UNKNOWN && <IconCondition condition={newConditionIndices[conditionIndices.UNKNOWN].iconID} />;
        };

        return (
            <Tippy
                content={
                    <div className='threshold-tooltip'>
                        <span>{translate('ABB.Powertrain.Frontend.conditionOverviewWithAlarmLabel')} <b>{groupOfKPIs[conditionIndices.POOR]?.length || 0}</b></span>
                        <span>{translate('ABB.Powertrain.Frontend.conditionOverviewWithAlertLabel')} <b>{groupOfKPIs[conditionIndices.TOLERABLE]?.length || 0}</b></span>
                    </div>
                }
                interactive
                interactiveBorder={10}
                animation='scale'
                theme='light-border'
                trigger='mouseenter'
                maxWidth={450}
                placement='right'
                offset='-85,0'
            >
                <div>
                    {renderKPIs()}
                </div>
            </Tippy>
        );
    }, [item]);

    return (
        <div className={`condition-index threshold ${isLeftPanelclosed ? 'cell' : 'left-sidebar-cell'}`}>
            <div>{renderThresholdConditions}</div>
        </div>
    );
});

ThresholdViewComponent.propTypes = {
    item: PropTypes.shape({
        threshold: PropTypes.shape({
            KPIs: PropTypes.arrayOf(PropTypes.shape({
                condition: PropTypes.string
            })),
            condition: PropTypes.string
        })
    }),
    isLabelVisible: PropTypes.bool,
    leftPanelSize: PropTypes.number
};

export default ThresholdViewComponent;
